import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-product-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = {
  key: 0,
  class: "form-group mb-15 mb-sm-20 mb-md-25"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Shipping Address ", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "invalid-feedback",
  id: "shippingAddressError"
}, null, -1)
const _hoisted_9 = { class: "col-md-12" }
const _hoisted_10 = {
  key: 0,
  class: "form-group mb-15 mb-sm-20 mb-md-25"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Marketplace ", -1)
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["value"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "invalid-feedback",
  id: "productTypeError"
}, null, -1)
const _hoisted_15 = { class: "col-md-12 mb-25" }
const _hoisted_16 = { class: "d-flex mb-15 justify-content-between" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold" }, " Order Items ", -1)
const _hoisted_18 = { class: "list-group" }
const _hoisted_19 = {
  key: 0,
  class: "list-group-item list-group-item-warning fw-medium fs-md-15"
}
const _hoisted_20 = { class: "d-flex flex-column" }
const _hoisted_21 = { class: "mb-1 fs-md-15 fs-lg-16" }
const _hoisted_22 = { class: "dropdown" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("button", {
  class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition fs-20 no-after text-paragraph",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
], -1)
const _hoisted_24 = { class: "dropdown-menu" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_29 = { class: "col-md-12" }
const _hoisted_30 = {
  class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16",
  type: "submit"
}
const _hoisted_31 = {
  class: "modal fade",
  id: "addOrderItemModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_32 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_33 = { class: "modal-content" }
const _hoisted_34 = { class: "modal-header" }
const _hoisted_35 = { class: "modal-title fs-5" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_37 = { class: "modal-body" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-md-2" }
const _hoisted_40 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Quantity", -1)
const _hoisted_42 = { class: "col-md-10" }
const _hoisted_43 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Product", -1)
const _hoisted_45 = { class: "modal-footer" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}, "Close", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_model_select = _resolveComponent("model-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitCreateOrUpdateOrder && _ctx.submitCreateOrUpdateOrder(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.customer)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _hoisted_6,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select shadow-none fw-semibold rounded-0",
                      name: "shippingAddress",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.shippingAddressId) = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addresses, (address) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: address.id,
                          key: address.id
                        }, _toDisplayString(address.name) + ", " + _toDisplayString(address.address_line_1) + _toDisplayString(address.address_line_2 ? ', '+address.address_line_2 : '') + ", " + _toDisplayString(address.postal_code) + " " + _toDisplayString(address.city) + ", " + _toDisplayString(address.state_or_region) + ", " + _toDisplayString(address.country_code), 9, _hoisted_7))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.shippingAddressId]
                    ]),
                    _hoisted_8
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_ctx.customer)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select shadow-none fw-semibold rounded-0",
                      name: "marketplace",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.marketplaceId) = $event)),
                      disabled: _ctx.orderItems.length
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.marketplaces, (marketplace) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: marketplace.id,
                          key: marketplace.id
                        }, _toDisplayString(marketplace.name), 9, _hoisted_13))
                      }), 128))
                    ], 8, _hoisted_12), [
                      [_vModelSelect, _ctx.marketplaceId]
                    ]),
                    _hoisted_14
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-primary btn-sm position-relative",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#addOrderItemModal",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addOrderItemClicked()))
                }, "Add Order Item")
              ]),
              _createElementVNode("ul", _hoisted_18, [
                (_ctx.orderItems.length == 0)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_19, "Please add items to the order."))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderItems, (orderItem) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "list-group-item fw-medium fs-md-15 d-flex justify-content-between",
                    key: orderItem.id
                  }, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("p", _hoisted_21, _toDisplayString(orderItem.quantity) + " x " + _toDisplayString(orderItem.name), 1),
                      _createElementVNode("small", null, "SKU: " + _toDisplayString(orderItem.sku), 1)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("ul", _hoisted_24, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#addOrderItemModal",
                            class: "dropdown-item d-flex align-items-center",
                            onClick: ($event: any) => (_ctx.editOrderItem(orderItem.sku))
                          }, [
                            _hoisted_26,
                            _createTextVNode(" Edit ")
                          ], 8, _hoisted_25)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center cursor-pointer",
                            onClick: ($event: any) => (_ctx.deleteOrderItem(orderItem.sku))
                          }, [
                            _hoisted_28,
                            _createTextVNode(" Delete")
                          ], 8, _hoisted_27)
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("button", _hoisted_30, _toDisplayString(_ctx.order ? 'Update' : 'Create') + " Order ", 1)
            ])
          ])
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("h1", _hoisted_35, _toDisplayString(_ctx.updateItemProductUid ? 'Edit' : 'Add') + " Order Item", 1),
            _hoisted_36
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    step: "1",
                    class: "form-control shadow-none rounded-0 text-black",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newOrderItemQty) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.newOrderItemQty]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createVNode(_component_model_select, {
                    class: "form-control shadow-none rounded-0 text-black",
                    placeholder: "e.g. Black Wristband",
                    name: "newOrderItemProductUid",
                    modelValue: _ctx.newOrderItemProductUid,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newOrderItemProductUid) = $event)),
                    options: _ctx.newOrderItemOptions,
                    onSearchchange: _ctx.updateProductSearch
                  }, null, 8, ["modelValue", "options", "onSearchchange"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _hoisted_46,
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addOrUpdateOrderItem && _ctx.addOrUpdateOrderItem(...args))),
              class: "btn btn-outline-primary"
            }, _toDisplayString(_ctx.updateItemProductUid ? 'Update' : 'Add'), 1)
          ])
        ])
      ])
    ])
  ], 64))
}